import React, { useEffect } from "react";
import { I } from "./icons";

/** A dialog that lives inside `.cxp`, so it inherits the design system instead of being
 *  portalled to document.body where none of the portal tokens exist. */
export function Modal({ open, onClose, title, sub, children, footer, width = 560, testId }) {
  useEffect(() => {
    if (!open) return undefined;
    const esc = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", esc);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="cx-modal" data-testid={testId}>
      <div className="cx-modal-back" onClick={onClose} />
      <div className="card cx-modal-card" style={{ maxWidth: width }}>
        <div className="card-h">
          <div style={{ minWidth: 0 }}>
            <div className="card-t">{title}</div>
            {sub && <div className="sec-sub" style={{ marginTop: 4 }}>{sub}</div>}
          </div>
          <button className="side-out" style={{ color: "var(--mut)" }} onClick={onClose} aria-label="Close"
                  data-testid={testId ? `${testId}-close` : undefined}>
            <I.close />
          </button>
        </div>
        <div className="card-b" style={{ maxHeight: "68vh", overflow: "auto" }}>{children}</div>
        {footer && <div className="card-f" style={{ justifyContent: "flex-end" }}>{footer}</div>}
      </div>
    </div>
  );
}

export default Modal;
